// ============================================================================
// Widget — Recovery Book Snapshot
// Top-of-dashboard KPI: total OS, NPA OS, secured / unsecured split.
// ============================================================================
import React from 'react';
import ReactECharts from 'echarts-for-react';
import WidgetShell from './WidgetShell';
import {
  mockRecoveryBook,
  fmtAmount,
  fmtCount,
} from '../executiveMockData';

const RecoveryBookSnapshotWidget: React.FC = () => {
  const d = mockRecoveryBook;
  const npaPct = (d.npaOutstanding / d.totalOutstanding) * 100;

  const donutOption = {
    tooltip: {
      trigger: 'item',
      formatter: (p: any) => `${p.name}<br/>${fmtAmount(p.value)} (${p.percent}%)`,
    },
    legend: { show: false },
    series: [
      {
        type: 'pie',
        radius: ['58%', '85%'],
        avoidLabelOverlap: true,
        itemStyle: { borderRadius: 3, borderColor: '#fff', borderWidth: 1 },
        label: { show: false },
        data: [
          { name: 'Secured',   value: d.securedOutstanding,   itemStyle: { color: '#16a34a' } },
          { name: 'Unsecured', value: d.unsecuredOutstanding, itemStyle: { color: '#d97706' } },
        ],
      },
    ],
  };

  return (
    <WidgetShell
      title="Recovery Book"
      subtitle={`${fmtCount(d.actionableAccounts)} actionable accounts · +${d.newThisPeriod} new this period`}
    >
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 130px', gap: '1rem', alignItems: 'center' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
          <Kpi   label="Total Outstanding" value={fmtAmount(d.totalOutstanding)}    accent="#1e3a8a" big />
          <Split
            left={{ label: 'NPA OS', value: fmtAmount(d.npaOutstanding), color: '#dc2626' }}
            right={{ label: 'NPA %', value: `${npaPct.toFixed(1)}%`,     color: '#dc2626' }}
          />
          <Split
            left={{ label: 'Secured',   value: fmtAmount(d.securedOutstanding),   color: '#16a34a' }}
            right={{ label: 'Unsecured', value: fmtAmount(d.unsecuredOutstanding), color: '#d97706' }}
          />
        </div>
        <div>
          <ReactECharts option={donutOption} style={{ height: 140, width: '100%' }} />
          <div style={{ textAlign: 'center', fontSize: '0.7rem', color: 'var(--text-secondary)', marginTop: '0.25rem' }}>
            Secured vs Unsecured
          </div>
        </div>
      </div>
    </WidgetShell>
  );
};

const Kpi: React.FC<{ label: string; value: string; accent: string; big?: boolean }> = ({ label, value, accent, big }) => (
  <div>
    <div style={{ fontSize: '0.7rem', color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: '0.04em' }}>{label}</div>
    <div style={{ fontSize: big ? '1.65rem' : '1.05rem', fontWeight: 700, color: accent, fontVariantNumeric: 'tabular-nums' }}>{value}</div>
  </div>
);

const Split: React.FC<{ left: { label: string; value: string; color: string }; right: { label: string; value: string; color: string } }> = ({ left, right }) => (
  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
    <Kpi label={left.label}  value={left.value}  accent={left.color} />
    <Kpi label={right.label} value={right.value} accent={right.color} />
  </div>
);

export default RecoveryBookSnapshotWidget;
